import { render, staticRenderFns } from "./AdherenceIndicators.vue?vue&type=template&id=022271ff&scoped=true&"
import script from "./AdherenceIndicators.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicators.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicators.vue?vue&type=style&index=0&id=022271ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022271ff",
  null
  
)

export default component.exports